<template>
  <div class='h100'>
    <div align='center'>
      <ejs-chart ref='singleCallFailCountChart' style='display:block' :height='height' :width='width' align='center' :primaryXAxis='primaryXAxis'
                 :primaryYAxis='primaryYAxis' :chartArea='chartArea' :tooltip='tooltip' :legendSettings='legend' selectionMode='DragX' >
        <e-series-collection>
          <e-series :dataSource='seriesData2' type='Column' xName='x' yName='y' :name='$t("TS.callFailedCount")' width=2 :marker='marker' fill='#FF2727'> </e-series>
          <e-series :dataSource='seriesData1' type='Column' xName='x' yName='y' :name='$t("TS.callCount")' width=2 :marker='marker' fill='#3BA1FF' > </e-series>
        </e-series-collection>
      </ejs-chart>
    </div>
    <CallDetailGrid ref='callDetailGrid'></CallDetailGrid>
  </div>
</template>

<script>

import Vue from 'vue';
import { Browser } from '@syncfusion/ej2-base';
import { ChartPlugin, ColumnSeries, Category, DataLabel, Tooltip, Legend, Zoom, ScrollBar, Selection } from '@syncfusion/ej2-vue-charts';
import CallDetailGrid from '../CallCountStatistics/CallDetailGrid';
Vue.use(ChartPlugin);

export default {
  name: 'SingleCallFailCountDialog',
  components: {
    CallDetailGrid
  },
  data() {
    return {
      seriesData1: [],
      seriesData2: [],
      /* seriesData: [
         { x: '00:00~01:00', y: 37 }, { x: '01:00~02:00', y: 23 }, { x: '02:00~03:00', y: 18 },{ x: '03:00~04:00', y: 16 },{ x: '04:00~05:00', y: 16 },{ x: '05:00~06:00', y: 37 }, { x: '06:00~07:00', y: 23 }, { x: '07:00~08:00', y: 18 },{ x: '08:00~09:00', y: 46 }, { x: '09:00~10:00', y: 27 }, { x: '10:00~11:00', y: 26 },{ x: '11:00~12:00', y: 46 }, { x: '12:00~13:00', y: 27 }, { x: '13:00~14:00', y: 56 },{ x: '14:00~15:00', y: 46 }, { x: '15:00~16:00', y: 27 }, { x: '17:00~18:00', y: 56 },{ x: '18:00~19:00', y: 46 }, { x: '19:00~20:00', y: 27 }, { x: '20:00~21:00', y: 56 },{ x: '21:00~22:00', y: 46 }, { x: '22:00~23:00', y: 27 }
       ], */
      primaryXAxis: {
        valueType: 'Category',
        zoomFactor: 1,
        interval: 1,
        majorGridLines: { width: 0 },
        edgeLabelPlacement: 'Shift',
        title: this.$t('TS.ts_call_type'),
      },
      // width: '60%',
      width: '800px',
      height: '280px',
      primaryYAxis:
        {
          title: this.$t('TS.ts_count'),
          labelFormat: '{value}'
        },
      marker:
        { dataLabel:
            { visible: false, position: 'Top', font: { fontWeight: '600', color: '#ffffff' }
            }
        },
      tooltip: {
        enable: true
      },
      legend: {
        visible: true,
        position: 'Top'
      },
      chartArea: {
        border: {
          width: 0
        }
      }
      // title: '单周期呼叫失败数统计',
    };
  },
  props: [
    'singledata'
  ],
  provide: {
    chart: [ColumnSeries, Legend, DataLabel, Category, Tooltip, Zoom, ScrollBar, Selection]
  }
};

</script>

<style scoped>

</style>
